(function () {
  var DEFAULT = 'M10 - W11.5';
  // The size this shopper last picked or added to the cart (saved by assets/cleats-buy.js)
  var saved = '';
  try { saved = localStorage.getItem('mirrorless.size') || ''; } catch (e) {}
  // A link that names a size (?variant=...) keeps that size instead of the default one
  var userChose = /[?&]variant=/.test(location.search);

  // ---- Pre-select the remembered size, or the default one if that is sold out (Globo swatch app markup) ----
  function currentLabel() {
    var checked = document.querySelector('.globo-swatch-list input[type="radio"]:checked');
    if (!checked) return '';
    var l = document.querySelector('label[for="' + checked.id + '"]');
    return l ? l.textContent.trim() : '';
  }

  function inStock(label) {
    var ok = false;
    document.querySelectorAll('.globo-swatch-list input[type="radio"]').forEach(function (r) {
      if (r.disabled || r.closest('.globo-out-of-stock')) return;
      var l = document.querySelector('label[for="' + r.id + '"]');
      if (l && l.textContent.trim() === label) ok = true;
    });
    return ok;
  }

  function pick() {
    var target = saved && inStock(saved) ? saved : DEFAULT;
    if (userChose || currentLabel() === target) return;
    document.querySelectorAll('.globo-swatch-list input[type="radio"]').forEach(function (r) {
      if (r.disabled || r.checked || r.closest('.globo-out-of-stock')) return;
      var l = document.querySelector('label[for="' + r.id + '"]');
      if (l && l.textContent.trim() === target) r.click();
    });
  }

  document.addEventListener('change', function (e) {
    if (e.isTrusted && e.target.matches && e.target.matches('.globo-swatch-list input')) userChose = true;
  }, true);

  [0, 300, 800, 1500, 2500, 4000].forEach(function (t) { setTimeout(pick, t); });

  // ---- Rating stars + "see their feedback" links scroll to the reviews section ----
  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('.loox-rating, [data-scroll-reviews]');
    if (!r) return;
    var t = document.querySelector('[id$="__rich_text_mfdRGY"]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  // ---- "Inspired by" verse bubble on the gallery + popup ----
  function initVerse() {
    var src = document.getElementById('verse-story');
    var gallery = document.querySelector('.product-gallery');
    if (!src || !gallery) return;

    if (!document.querySelector('.verse-modal')) {
      var dlg = document.createElement('dialog');
      dlg.className = 'verse-modal';
      dlg.innerHTML = '<div class="verse-modal__sheet"><button type="button" class="verse-modal__close" aria-label="Close"></button>' + src.innerHTML + '</div>';
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('.verse-modal__close')) dlg.close();
      });
      document.body.appendChild(dlg);
    }

    if (!gallery.querySelector('.verse-bubble')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'verse-bubble';
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.innerHTML = '<span class="verse-bubble__icon" aria-hidden="true"></span><span class="verse-bubble__label"></span><span class="verse-bubble__go" aria-hidden="true"></span>';
      btn.querySelector('.verse-bubble__label').textContent = src.getAttribute('data-label') || '';
      btn.addEventListener('click', function () {
        var d = document.querySelector('.verse-modal');
        if (d && d.showModal) d.showModal();
      });
      gallery.appendChild(btn);
    }
  }

  // ---- Photo gallery (phones): the visible height follows the swipe ----
  // The carousel stays at its tallest-photo height; a clipping box around it is resized every frame, blending
  // between the heights of the two photos being swiped between, so the page below moves in step with the swipe.
  function initGallery() {
    var sc = document.querySelector('.product-gallery scroll-carousel[adaptive-height]');
    if (!sc || sc.__followBound) return;
    var box = sc.closest('.product-gallery__image-list');
    if (!box) return;
    sc.__followBound = true;

    // Stop the theme from resizing the carousel itself after each swipe
    var style = document.createElement('style');
    style.textContent = '.product-gallery scroll-carousel[adaptive-height]{max-height:none !important}';
    document.head.appendChild(style);

    var active = false;

    function release() {
      if (!active) return;
      box.style.removeProperty('display');
      box.style.removeProperty('height');
      box.style.removeProperty('clip-path');
      active = false;
    }

    function follow() {
      var cells = Array.prototype.filter.call(sc.children, function (c) { return !c.hasAttribute('hidden'); });
      var scrollable = sc.scrollWidth > sc.clientWidth + 1;

      if (cells.length < 2 || !scrollable) {
        release();
        return;
      }

      var step = cells[1].offsetLeft - cells[0].offsetLeft;
      if (!(step > 0)) return;

      var pos = Math.max(0, Math.min(cells.length - 1, sc.scrollLeft / step));
      var i = Math.min(cells.length - 2, Math.floor(pos));
      var t = pos - i;
      var h = cells[i].offsetHeight * (1 - t) + cells[i + 1].offsetHeight * t;
      if (!(h > 0)) return;

      if (!active) {
        box.style.display = 'block';
        box.style.clipPath = 'inset(0 -100vw 0 -100vw)';
        active = true;
      }
      box.style.height = h.toFixed(1) + 'px';
    }

    sc.addEventListener('scroll', follow, { passive: true });
    sc.addEventListener('carousel:filter', follow);
    window.addEventListener('resize', follow);
    window.addEventListener('orientationchange', follow);
    sc.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', follow, { once: true });
    });

    follow();
  }

  // ---- "Email me when available": shown only while the selected size is sold out ----
  // The back-in-stock app sometimes misses a size change, so follow the theme's own Add to cart button instead.
  var bisNudges = 0;

  function selectedIsSoldOut() {
    var atc = document.querySelector('.product-info buy-buttons button');
    return !!(atc && atc.disabled && /sold\s*out/i.test(atc.textContent));
  }

  function syncBackInStock() {
    var soldOut = selectedIsSoldOut();
    document.querySelectorAll('.gBackInStock-Button').forEach(function (btn) {
      if (btn.parentElement) btn.parentElement.style.display = soldOut ? '' : 'none';
    });

    if (!soldOut) {
      bisNudges = 0;
      return;
    }

    // Sold out, but the app hasn't drawn its button: re-select the current size once or twice to wake it up
    if (!document.querySelector('.product-info .gBackInStock-Button') && bisNudges < 2) {
      var checked = document.querySelector('.globo-swatch-list input:checked');
      var label = checked && document.querySelector('label[for="' + checked.id + '"]');
      if (label) {
        bisNudges++;
        label.click();
      }
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.globo-swatch-list input')) {
      [120, 450, 900, 1600].forEach(function (t) { setTimeout(syncBackInStock, t); });
    }
  }, true);

  // ---- Reviews: this product's reviews first, with a switch to reviews from all products ----
  // The Loox carousel is an iframe; its address takes a productIds filter. The two cards from the "Reviews summary"
  // section switch it. location.replace is used so it never adds a browser-history entry.
  var reviewsReady = false;

  function currentProductId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
    if (input && input.value) return input.value;
    try {
      if (window.meta && window.meta.product && window.meta.product.id) return String(window.meta.product.id);
    } catch (e) {}
    try {
      if (window.ShopifyAnalytics.meta.product.id) return String(window.ShopifyAnalytics.meta.product.id);
    } catch (e) {}
    return null;
  }

  function initReviews() {
    if (reviewsReady) return;
    var frame = document.querySelector('iframe[id^="LOOX-V2_CAROUSEL"]');
    var pid = currentProductId();
    if (!frame || !pid || !frame.src) return;
    reviewsReady = true;

    var summary = document.querySelector('[data-reviews-summary]');
    var cards = summary ? summary.querySelectorAll('[data-mode]') : [];
    var base = frame.src;
    var mode = null;
    var fellBack = false;

    function navigate(next) {
      var u = new URL(base, location.href);
      if (next === 'product') u.searchParams.set('productIds', pid);
      else u.searchParams.delete('productIds');
      try {
        frame.contentWindow.location.replace(u.toString());
      } catch (e) {
        frame.src = u.toString();
      }
    }

    function setMode(next) {
      if (next === mode) return;
      mode = next;
      navigate(mode);
      cards.forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.getAttribute('data-mode') === mode));
      });
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () { setMode(c.getAttribute('data-mode')); });
    });

    window.addEventListener('message', function (e) {
      if (e.source !== frame.contentWindow || mode !== 'product' || fellBack) return;
      var d;
      try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }
      if (d && d.type === 'resize' && d.height < 140) {
        fellBack = true;
        setMode('all');
      }
    });

    var noneYet = summary && summary.querySelector('[data-mode="product"] .reviews-summary__score--none');
    setMode(noneYet ? 'all' : 'product');
  }

  // ---- Glass bubble behind the image dots, title, rating and price ----
  // One background layer (a pseudo-element on the info column) spanning from the dots to the bottom of the last row.
  // Positions come from layout offsets inside the info column, so scrolling or the phone's address bar can't change
  // the result. It is recomputed whenever anything in the block resizes, and on scroll / resize / page show.
  var observed = [];
  var resizeObserver = null;
  var dotsOffset = null; // dots top relative to the info column top (negative), measured once per width
  var dotsWidth = 0;
  var lastGood = null;

  function childOf(list, el) {
    while (el && el.parentElement !== list) el = el.parentElement;
    return el;
  }

  function offsetWithin(el, root) {
    var y = 0;
    while (el && el !== root) {
      y += el.offsetTop;
      el = el.offsetParent;
    }
    return el === root ? y : null;
  }

  function layoutBubble() {
    var info = document.querySelector('.product-info');
    if (!info) return;
    var list = info.querySelector('.product-info__block-list');
    if (!list) return;

    var titleItem = childOf(list, list.querySelector('.product-title'));
    var savingsItem = childOf(list, list.querySelector('.cleats-savings'));
    var priceItem = childOf(list, list.querySelector('[data-block-type="price"]'));
    var ratingItem = childOf(list, list.querySelector('.loox-rating'));
    if (!titleItem || !(savingsItem || priceItem)) return;

    if (getComputedStyle(info).position === 'static') info.style.position = 'relative';

    // Reset the title nudge first so measurements start from the natural layout
    titleItem.style.removeProperty('margin-top');

    // Where the image dots sit relative to the top of the info column (measured once per screen width)
    var dots = document.querySelector('.product-gallery carousel-navigation.page-dots');
    var dotsVisible = false;
    if (dots && dots.getClientRects().length) {
      if (dotsOffset === null || dotsWidth !== window.innerWidth) {
        var measured = dots.getBoundingClientRect().top - info.getBoundingClientRect().top;
        if (measured >= -140 && measured <= 0) {
          dotsOffset = measured;
          dotsWidth = window.innerWidth;
        }
      }
      dotsVisible = dotsOffset !== null;
    }

    var titleTop = offsetWithin(titleItem, info);
    if (titleTop === null) return;
    if (dotsVisible && dotsOffset >= titleTop) dotsVisible = false;

    // Without a savings pill the rating/price row is the last thing in the bubble: give it more room below
    // and pull the title up toward the dots so the top, middle and bottom gaps read evenly.
    var hasSavings = !!savingsItem;
    if (dotsVisible && !hasSavings) {
      titleItem.style.setProperty('margin-top', '-10px', 'important');
      titleTop = offsetWithin(titleItem, info);
      if (titleTop === null) return;
    }

    var firstTop = dotsVisible ? dotsOffset : titleTop;

    var bottom = 0;
    [savingsItem, priceItem, ratingItem].forEach(function (el) {
      if (!el) return;
      var t = offsetWithin(el, info);
      if (t !== null) bottom = Math.max(bottom, t + el.offsetHeight);
    });

    var padTop = 14;
    var padBottom = hasSavings ? 14 : 20;
    var top = firstTop - padTop;
    var height = bottom - firstTop + padTop + padBottom;

    // Sanity check: the title block is never taller than ~300px. If a reading looks wrong, keep the last good one.
    if (!(height >= 90 && height <= 320)) {
      if (lastGood) {
        top = lastGood.top;
        height = lastGood.height;
      } else {
        return;
      }
    } else {
      lastGood = { top: top, height: height };
    }

    info.style.setProperty('--bubble-top', top + 'px');
    info.style.setProperty('--bubble-height', height + 'px');
    info.classList.add('has-bubble');

    if ('ResizeObserver' in window) {
      var targets = [info, info.closest('.product'), titleItem, ratingItem, priceItem, savingsItem].filter(Boolean);
      var changed = targets.length !== observed.length || targets.some(function (t, i) { return t !== observed[i]; });
      if (changed) {
        if (resizeObserver) resizeObserver.disconnect();
        resizeObserver = new ResizeObserver(schedule);
        targets.forEach(function (t) { resizeObserver.observe(t); });
        observed = targets;
      }
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      initVerse();
      initGallery();
      initReviews();
      layoutBubble();
      syncBackInStock();
    });
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('visibilitychange', schedule);
  schedule();
})();